import 'regenerator-runtime/runtime';
import intersect from '@alpinejs/intersect';
import trap from '@alpinejs/trap';
import Alpine from 'alpinejs';
import { gsap } from 'gsap';
import { GSDevTools } from 'gsap/GSDevTools';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { backToTopBehavior } from '../patterns/02-molecules/back-to-top/back-to-top.behavior';
import { menuSubnav } from '../patterns/02-molecules/menu/menu.behavior';
import { mediahawkBehavior } from '../patterns/02-molecules/mediahawk/mediahawk.behavior';
import { selectBehavior } from '../patterns/01-atoms/forms/forms.behavior';
import { sliderBehavior } from '../patterns/03-organisms/slider/slider.behavior';
import { timelineBehavior } from '../patterns/03-organisms/timeline/timeline.behavior';
import { homepageHeroBehavior } from '../patterns/03-organisms/homepage-hero/homepage-hero.behavior';
import { teaserParagraphBehavior } from '../patterns/02-molecules/teaser-paragraph/teaser-paragraph.behavior';
import { headerBehavior } from '../patterns/03-organisms/header/header.behavior';
import { formModalBehavior } from '../patterns/01-atoms/form-modal/form-modal.behavior';
import { packageCollectionBehavior } from '../patterns/03-organisms/package-collection/package-collection.behavior';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, DrawSVGPlugin, GSDevTools);
Alpine.plugin(intersect);
Alpine.plugin(trap);
window.Alpine = Alpine;
Drupal.behaviors.alpinejs = {
  isStarted: false,
  gsDevTools: false,
  attach: function attach() {
    this.registerEvents();
    this.start();
  },

  /**
   * Register custom Alpine data functions.
   */
  alpineData: function alpineData() {
    backToTopBehavior();
    menuSubnav();
    mediahawkBehavior();
    selectBehavior();
    sliderBehavior();
    timelineBehavior();
    homepageHeroBehavior();
    teaserParagraphBehavior();
    headerBehavior();
    formModalBehavior();
    packageCollectionBehavior();
  },
  start: function start() {
    document.addEventListener('alpine:init', function () {
      Alpine.data('menu', menuSubnav());
      Alpine.data('slider', sliderBehavior());
      Alpine.data('mediahawk', mediahawkBehavior());
      Alpine.data('forms', selectBehavior());
      Alpine.data('timeline', timelineBehavior());
      Alpine.data('teaser-paragraph', teaserParagraphBehavior());
      Alpine.data('form-modal', formModalBehavior());
      Alpine.data('package-collection', packageCollectionBehavior());
      Alpine.data('header', headerBehavior());
      Alpine.data('homepage-hero', homepageHeroBehavior());
      Alpine.data('back-to-top', backToTopBehavior());
    });

    if (this.gsDevTools) {
      this.gsDevTools = GSDevTools.create();
    }

    if (this.isStarted === false) {
      Alpine.start();
    }
  },
  registerEvents: function registerEvents() {
    var _this = this;

    document.addEventListener('alpine:initialized', function () {
      if (_this.isStarted === false) {
        _this.isStarted = true;
      }
    });
  }
};